import React from "react"
import { useSetRecoilState } from "recoil"
import { modal } from "store/atoms"
import { ModalContent } from "./styles"

import { Button, Text } from "components"

const Error: React.FC = () => {
  const setModal = useSetRecoilState(modal)

  const close = () => {
    // @ts-ignore
    setModal({ ...modal, show: false })
  }

  return (
    <ModalContent>
      <Text textId="modalErrorHead" type="h3" />
      <Text textId="modalErrorBody" type="p" />
      <Button colour="secondary2" textId="buttonOK" onClick={close} />
    </ModalContent>
  )
}

export default Error
